<template>
    <div class="detail-view">
      <div class="tag-top-detail player-detail">
        <age-tag :age-code="contentInfo.targetage" content-type="movie"></age-tag>
        <div class="tag-top" v-top-tag-list="contentInfo.moviemarks"></div>
      </div>

      <div class="title-box" @click.prevent="toggleInfo">
        <p class="view-title">
            <span v-html="contentInfo.title"></span>
        </p>
        <span class="info-toggle-button">
          <component :is="getToggleButton"></component>
        </span>
      </div>

      <div class="desc-info-box">
        <span class="desc-info">
          <star-rating :rating="contentInfo.rating"></star-rating>
        </span>
          <movie-genre :content-info="contentInfo"/>
      </div>
      <div class="icon-wrap">
        <icon-box-sns-share :content-info="contentInfo"></icon-box-sns-share>
        <icon-box-zzim :content-info="contentInfo"></icon-box-zzim>
      </div>
      <div class="tag-hash" v-if="tagList.length > 0">
        <ul>
          <li @click="clickTag(tag)" v-for="(tag, index) in tagList" :key="tag.value + index">#{{tag.text}}</li>
        </ul>
      </div>
      <a href="#" @click.prevent="moveToMovie" class="live-channel"  v-if="contentInfo.originalmovieid !== ''">
        <span>본편 보러가기</span>
        <NextButtonWhite/>
      </a>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { MovieInfoService } from '@/common/api/api.service'
import router from '@/router'
import AgeTag from '@/components/tags/AgeTag'
import MovieGenre from '@/components/play/MovieGenre'
import StarRating from '@/components/play/StartRating'
import { topTagList } from '@/common/directives'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import OpenInfoButton from '@/assets/svg/common/ic_title_open_b.svg'
import CloseInfoButton from '@/assets/svg/common/ic_title_close_b.svg'
import IconBoxZzim from '@/components/play/IconBoxZzim'
export default {
  name: 'MoviePlayerDetailInfo',
  components: {
    IconBoxZzim,
    IconBoxSnsShare,
    AgeTag,
    MovieGenre,
    StarRating,
    NextButtonWhite,
    OpenInfoButton,
    CloseInfoButton
  },
  directives: {
    topTagList
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    moveToMovie () {
      MovieInfoService.getMovieMetaInfo({ movieID: this.contentInfo.originalmovieid }).then(({ data }) => {
        router.push({
          name: 'player',
          params: {
            section: 'movie'
          },
          query: { movieid: data.movieid }
        })
      }).catch((err) => {
        console.log(err, '컨텐츠 아이디 획득에 실패 했습니다.')
      })
    }
  },
  props: {
    contentInfo: { type: Object },
    getToggleButton: { type: String },
    toggleInfo: { type: Function },
    tagList: { type: Array },
    clickTag: { type: Function }
  },
  mounted () {}
}
</script>
